import { useContext, createContext } from "react";

type ListViewStyle = "list" | "grid";

interface AppContextType {
  changeListViewStyle: (paramName?: ListViewStyle) => void;
  preferredListViewStyle: ListViewStyle;
  cartOpen?: boolean;
  toggleCart?: (paramName?: boolean) => void;
  clientChooserOpen?: boolean;
  toggleClientChooser?: (paramName?: boolean | any) => void | any;
}

export const Context = createContext<AppContextType>({
  changeListViewStyle: () => {},
  preferredListViewStyle: "list",
});

const useAppContext = () => useContext(Context);

export default useAppContext;
